<template>
  <transition name="fade">
    <button
      v-if="played"
      :class="{'controls-forward': true, dark: isDark, disabled: !epi || !epi.id}"
      :disabled="!epi || !epi.id"
      aria-label="15 Seconds Forward"
      @click.prevent="forward"
      @touchstart.prevent="forward"
    >
      <IconForward />
    </button>
  </transition>
</template>

<script>
import IconForward from '../assets/svg/forward.svg'

export default {
  components: { IconForward },
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  computed: {
    epi () { return this.store.state.episode },
    isDark () { return this.store.state.isDark },
    played () { return this.store.state.hasPlayed }
  },
  methods: {
    forward () {
      this.store.forward()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';

button {
  background: none;
  border: none;
  cursor: pointer;
  margin: 0 0 0 10px;
  padding: 0;

  &.dark {
    svg {
      fill: $white-000;
    }
  }
  &.disabled {
    background-color: transparent;
    cursor: default;
    svg {
      fill: $grey-300;
    }
    &.dark {
      svg {
        fill: $grey-700;
      }
    }
  }
}
</style>
